/** Fase 2 (W1): Início em seções, seletor de período, barra superior com índices e faixa de ambiente. */
export const inicioPt = {
  inicio: {
    kicker: 'Visão geral',
    titulo: 'Olá, {{nome}}',
    indicadores: 'Indicadores',
    semIndicadores: 'Instale módulos para ver indicadores aqui.',
    secoes: { financeiro: 'Financeiro', comercial: 'Comercial', operacao: 'Operação', pessoas: 'Pessoas e aprendizado', sistema: 'Sistema' },
    etiqueta: { hoje: 'Hoje', agora: 'Agora', periodo: 'Período' },
    base: { caixa: 'Caixa', competencia: 'Mês de referência', emissao: 'Emissão' },
    verDetalhes: 'Ver detalhes',
    delta: {
      acima: '{{pct}} acima do período anterior',
      abaixo: '{{pct}} abaixo do período anterior',
      igual: 'Igual ao período anterior',
      semAnterior: 'Sem valor no período anterior',
      anterior: 'Período anterior: {{valor}}',
    },
    motivo: { erro: 'Não foi possível calcular este valor agora. Tente de novo em instantes.', tempo: 'O cálculo passou do tempo limite. Tente de novo em instantes.' },
    vazio: { padrao: 'Sem dados ainda', lista: 'Nada para mostrar agora', grafico: 'Sem movimentação no período' },
    acoesRapidas: 'Ações rápidas',
    acoes: {
      fatura: 'Nova fatura',
      contaPagar: 'Nova conta a pagar',
      lancamento: 'Novo lançamento',
      cliente: 'Novo cliente',
      oportunidade: 'Nova oportunidade',
      contrato: 'Novo contrato',
      agendamento: 'Agendar reunião',
      tarefa: 'Nova tarefa',
      compra: 'Nova compra',
      pedidoCompra: 'Novo pedido de compra',
      produto: 'Novo produto',
      funcionario: 'Novo funcionário',
      curso: 'Novo curso',
    },
    grafico: {
      entradas: 'Entradas',
      saidas: 'Saídas',
      saldo: 'Saldo acumulado',
      previsto: 'Saldo previsto',
      previstoLegenda: 'Saldo previsto (com as contas em aberto)',
      aria: 'Fluxo de caixa de {{de}} a {{ate}}, saldo acumulado no fim de {{saldo}}',
      tabela: 'Dados do gráfico de fluxo de caixa',
      data: 'Data',
      semana: 'Semana de {{data}}',
    },
    lista: {
      fatura: 'A receber',
      conta_pagar: 'A pagar',
      diasAtraso_one: '{{count}} dia de atraso',
      diasAtraso_other: '{{count}} dias de atraso',
      sem_categoria: 'Sem categoria',
      outras: 'Outras categorias',
      autor: { sistema: 'Sistema', chave: 'Chave de API' },
    },
    cards: {
      a_receber_semana: { rotulo: 'A receber', partes: { vencido: 'Vencido', hoje: 'Vence hoje', proximos_7: 'Próximos 7 dias' } },
      recebido_periodo: { rotulo: 'Recebido no período' },
      a_pagar: { rotulo: 'A pagar', partes: { vencido: 'Vencido', hoje: 'Vence hoje', proximos_7: 'Próximos 7 dias' } },
      pago_periodo: { rotulo: 'Pago no período' },
      saldo_contas: { rotulo: 'Saldo das contas', subtitulo_one: '{{count}} conta ativa', subtitulo_other: '{{count}} contas ativas' },
      resultado_caixa: { rotulo: 'Resultado de caixa', partes: { entradas: 'Entradas', saidas: 'Saídas' } },
      resultado_competencia: { rotulo: 'Resultado do mês (competência)', partes: { entradas: 'Receitas', saidas: 'Despesas' } },
      fluxo_caixa: { rotulo: 'Fluxo de caixa', valor: 'Saldo no fim do período', partes: { entradas: 'Entradas no período', saidas: 'Saídas no período', previsto: 'Saldo previsto no fim do período' } },
      faturamento_emitido: { rotulo: 'Faturamento emitido' },
      despesas_categoria: { rotulo: 'Despesas por categoria', vazio: 'Nenhuma despesa paga no período' },
      proximos_vencimentos: { rotulo: 'Próximos vencimentos', vazio: 'Nenhum vencimento nos próximos 15 dias' },
      maiores_devedores: { rotulo: 'Maiores devedores', vazio: 'Nenhum cliente com conta vencida' },
      conciliacao_pendente: { rotulo: 'Para conferir com o banco', partes: { entradas: 'Entradas para conferir com o banco', saidas: 'Saídas para conferir com o banco' } },
      oportunidades_abertas: { rotulo: 'Vendas em negociação', partes: { quantidade: 'Oportunidades abertas' } },
      ganhas_periodo: { rotulo: 'Ganhas no período', partes: { quantidade: 'Oportunidades ganhas', conversao: 'Taxa de conversão' } },
      conversas_nao_lidas: { rotulo: 'Conversas não lidas', partes: { minhas: 'Atribuídas a mim', sem_dono: 'Sem dono' } },
      clientes_ativos: { rotulo: 'Clientes ativos', partes: { novos_periodo: 'Novos no período' } },
      agenda_hoje: { rotulo: 'Agenda de hoje', subtitulo: 'Próximo às {{hora}}' },
      estoque_abaixo_minimo: { rotulo: 'Estoque abaixo do mínimo' },
      compras_a_receber: { rotulo: 'Compras a receber', partes: { atrasados: 'Com entrega atrasada' } },
      funcionarios_ativos: { rotulo: 'Funcionários ativos', partes: { admissoes: 'Admissões no período', desligamentos: 'Desligamentos no período' } },
      folha_ultima: { rotulo: 'Folha', subtitulo: 'Líquido do mês de referência {{mes}}', vazio: 'Nenhum mês fechado ainda' },
      documentos_vencendo: { rotulo: 'Documentos vencendo em 30 dias', partes: { vencidos: 'Já vencidos' } },
      treinamento_em_andamento: { rotulo: 'Treinamentos em andamento' },
      conectores_ativos: { rotulo: 'Conectores conectados', partes: { com_erro: 'Com erro' } },
      atividade_recente: { rotulo: 'Atividade recente', vazio: 'Nenhuma atividade registrada ainda' },
      mrr: { rotulo: 'Receita mensal recorrente (MRR)', partes: { pausado: 'Receita recorrente pausada', a_iniciar: 'Receita recorrente a iniciar' }, vazio: 'Nenhum contrato recorrente ainda' },
      reajustes_pendentes: { rotulo: 'Reajustes pendentes' },
      minhas_tarefas: { rotulo: 'Minhas tarefas abertas', partes: { atrasadas: 'Com prazo vencido', p1: 'Prioridade P1' } },
      cards_parados: { rotulo: 'Cards parados há mais de 7 dias', partes: { esperando_pessoa: 'Esperando decisão', mais_14: 'Parados há mais de 14 dias' } },
      novidades: { rotulo: 'Novidades', naoVistas_one: '{{count}} novidade que você ainda não viu', naoVistas_other: '{{count}} novidades que você ainda não viu', emDia: 'Você já viu todas as novidades', nova: 'Nova', verTodas: 'Ver todas as novidades' },
    },
  },
  periodo: {
    escolher: 'Escolher período',
    atual: 'Período: {{rotulo}}',
    atalhos: {
      hoje: 'Hoje',
      semana: 'Esta semana',
      mes: 'Mês atual',
      mes_passado: 'Mês passado',
      '30_dias': 'Últimos 30 dias',
      trimestre: 'Trimestre atual',
      ano: 'Ano atual',
      personalizado: 'Personalizado',
    },
    de: 'De',
    ate: 'Até',
    aplicar: 'Aplicar',
    invalido: 'Escolha a data inicial antes da final, com no máximo 3 anos.',
    aplicarPeriodo: 'Aplicar período',
    mes: 'Mês',
    mesAno: '{{mes}} / {{ano}}',
    mesInvalido: 'Escolha um mês válido.',
    rotuloAbas: 'Tipo de período',
    abas: { atalhos: 'Atalhos', mes: 'Mês específico', periodo: 'Período' },
  },
  // U15 F8: atalho rápido do topo.
  atalho: {
    abrir: 'Registrar rápido',
    titulo: 'Registrar rápido',
    oQue: 'O que registrar',
    novaTarefa: 'Nova tarefa',
    mensagemEquipe: 'Mensagem para a equipe',
    salvarTarefa: 'Salvar tarefa',
    enviarMensagem: 'Enviar mensagem',
    escolha: 'Escolha a pessoa ou o canal',
    para: 'Para',
    mensagem: 'Mensagem',
    canal: 'canal',
    tarefaCriada: 'Tarefa criada',
    verTarefa: 'Ver tarefa',
    mensagemEnviada: 'Mensagem enviada',
    abrirConversa: 'Abrir conversa',
  },
  barra: {
    titulo: 'Barra superior',
    indices: 'Índices',
    regiao: 'Índices econômicos do Banco Central',
    nomes: { igpm: 'IGP-M', ipca: 'IPCA', inpc: 'INPC', selic: 'SELIC' },
    mes12: '12m',
    acumulado: 'acumulado em 12 meses: {{valor}}',
    atualizado: 'Atualizado em {{data}}',
    vazio: 'Os índices do Banco Central aparecem aqui depois da primeira sincronização.',
    erro: 'Índices indisponíveis agora.',
    ocultar: 'Ocultar índices',
    mostrar: 'Mostrar índices',
    atualizarAgora: 'Atualizar índices agora',
    atualizacaoPedida: 'Atualização pedida ao Banco Central. Os índices aparecem em instantes.',
    recolherMenu: 'Recolher menu lateral',
    expandirMenu: 'Expandir menu lateral',
  },
  ambiente: {
    rotulo: 'Aviso de ambiente',
    homologacao: 'Ambiente de homologação. Dados de teste.',
    staging: 'Ambiente de staging. Dados de teste.',
    sandbox: 'Sandbox: dados de teste, nada aqui afeta a operação real.',
  },
  // Lote 19 (item 13): tela dividida.
  divisao: {
    abrirAoLado: 'Abrir ao lado',
    abrirEmAba: 'Abrir em outra aba do painel',
    tituloAbrir: 'Abrir esta tela ao lado (Ctrl+Alt+seta para a direita)',
    barra: 'Tela dividida',
    painel: 'Painel {{n}}',
    emUso: 'Em uso',
    painelEmUso: 'Painel {{n}}, em uso',
    divisoria: 'Divisória entre os painéis',
    proporcao: 'Painel 1 com {{p}}% da largura',
    trocar: 'Trocar lados',
    fechar: 'Fechar o painel {{n}}',
    opcoesDoItem: 'Opções de {{item}}',
    // Lista de 30/10 B (item 2 da ficha do Principal): o botão fixo da barra superior.
    botaoBarra: 'Tela dividida',
    dicaLigar: 'Dividir a tela em dois painéis, cada um com o seu sub-sistema (Ctrl+Alt+seta para a direita)',
    dicaDesligar: 'Voltar a um painel só',
  },
};
